export const formContent = {
    heading: 'Your business details',
    businessLogo: {
        id: 'businessLogo',
        label: '',
        defaultImage: '/img/logo-preview.png'
    },
    businessName: {
        id: 'businessName',
        label: 'Business name',
        validation: {
            required: "Business name is required"
        }
    },
    emailAddress: {
        id: 'emailAddress',
        label: 'Email',
        validation: {
            required: "Business email address required"
        }
    },
    tradingName: {
        id: 'tradingName',
        label: 'Trading name',
        validation: {
            required: "Trading name is required"
        }
    },
    businessAddress: {
        id: 'businessAddress',
        label: 'Business Address',
        validation: {
            required: "Business Address is required"
        }
    },
    ABN: {
        id: 'ABN',
        label: 'ABN',
        validation: {
            required: "ABN is required"
        }
    },
    firstName: {
        id: 'firstName',
        label: 'Contact first name',
        validation: {
            required: "Contact first name is required"
        }
    },
    lastName: {
        id: 'lastName',
        label: 'Contact last name',
        validation: {
            required: "Contact last name is required"
        }
    },
    mobileNumber: {
        id: 'mobileNumber',
        label: 'Mobile number',
        validation: {
            required: "Mobile number is required"
        }
    },
    landlineNumber: {
        id: 'landlineNumber',
        label: 'Landline number',
    },
    faxNumber: {
        id: 'faxNumber',
        label: 'Fax number',
    },
    webSiteUrl: {
        id: 'webSiteUrl',
        label: 'Website',
    },
    facebookLink: {
        id: 'facebookLink',
        label: 'Facebook link',
    },
    InstagramLink: {
        id: 'InstagramLink',
        label: 'Instagram link',
    },
    workingDay: {
        id: 'workingDay',
        label: "Working day",
        validation: {
            required: "Working Day is required"
        }
    },
    opeingHours: {
        id: 'opeingHours',
        label: 'Opeing Hours',
        validation: {
            required: "Opeing hours is required"
        }
    },
    closingHours: {
        id: 'closingHours',
        label: 'Closing Hours',
        validation: {
            required: "Closing hours is required"
        }
    },
    GetBusinessInfoImage: {
        id: 'GetBusinessInfoImage',
        label: 'Business info image',
        defaultImage: []
    },
    updateButton: {
        id: 'updateButton',
        label: 'Update Bussiness profile',
        type: 'submit'
    }
}
